export default {
	attributes: {
		design: 'basic',
		onlyOnePanelOpen: false,
		openStart: true,
		reverseArrow: false,
		containerBackgroundCustomSizeUnit: '%',
		containerTabletBackgroundCustomSizeUnit: '%',
		containerMobileBackgroundCustomSizeUnit: '%',
		title: 'Title for This Block',
		showTitle: true,
		titleLineHeightUnit: 'em',
		titleTabletLineHeightUnit: 'em',
		titleMobileLineHeightUnit: 'em',
		showArrow: true,
		showBorder: true,
		uniqueClass: 'ugb-872a8ec',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
	},
	innerBlocks: [
		{
			clientId: 'e6b76d8f-bb66-45fb-938f-ef35d5fca25f',
			name: 'core/paragraph',
			isValid: true,
			originalContent: '<p>Description for this block. Use this space for describing your block. Any text will do.</p>',
			attributes: {
				content: 'Description for this block. Use this space for describing your block. Any text will do.',
				dropCap: false,
			},
		},
	],
}

